import apiClient from './api'

export interface Practice {
  id: number
  name: string
  stateId: number
  stateName: string
  dentistCount: number
}

class PracticeService {
  async GetPractices() {
    try {
      const response = await apiClient.get<Practice[]>('/Admin/practices')
      return { success: true, data: response.data }
    } catch (err) {
      return { success: false, data: [] as Practice[] }
    }
  }

  async CreatePractice(name: string, stateId: number) {
    const response = await apiClient.post<Practice>('/Admin/practice', { name, stateId })
    return response.data
  }

  async RenamePractice(practiceId: number, name: string) {
    const response = await apiClient.put<Practice>(`/Admin/practice/${practiceId}`, { name })
    return response.data
  }

  async DeletePractice(practiceId: number) {
    const response = await apiClient.delete(`/Admin/practice/${practiceId}`)
    return response.data
  }
}

export default new PracticeService()
